import request from './request'
    baseNew
import {api,fringService,baseMember,orderCustomer,baseScenic,fileUploadUrl,faceUrl,orderInformation,baseNew} from './url'
export function findWebStorePageNavigationList(params) {
    return request({
        url: orderCustomer + '/storePageNavigationAction/findWebStorePageNavigationList',
        method: 'post',
        data: params
    });
}
// 订单列表
export function queryStoreProductGroupList(params) {
    return request({
        url: fringService + '/findScenicAction/queryStoreProductGroupList',
        method: 'post',
        data: params
    });
}
// 登录
export function memberLogin(params) {
    return request({
        url: baseMember + '/memberLoginRegisterAction/memberLogin',
        method: 'post',
        data: params
    });
}
// 注册
export function appRegistry(params) {
    return request({
        url: baseMember + '/memberLoginRegisterAction/memberRegistry',
        method: 'post',
        data: params
    });
}
// 验证码
export function generateDynamicCode(params) {
    return request({
        url: baseMember + '/memberLoginRegisterAction/generateDynamicCode',
        method: 'post',
        data: params
    });
}

export function createOrder(params) {
    return request({
        url: orderCustomer + '/capi' + '/scenicOrderAction/createOrder',
        method: 'post',
        data: params
    });
}

// 各业态商城C扫B支付接口
export function orderOnlinePay(params) {
    return request({
        url: orderCustomer + '/capi' + '/orderOnlinePayAction/orderOnlinePay',
        // url: 'http://192.168.30.33:2010/capi/orderOnlinePayAction/orderOnlinePay',
        method: 'post',
        data: params
    });
}

// 常用联系人下拉
export function findMemberFrequentContacts(params) {
    return request({
      url: baseMember +  '/capi' + '/memberFrequentContactAction/findMemberFrequentContacts',
      method: 'post',
      data: params
    });
  }

//查询可购年卡列表
export function findAppScenicCardListByGroupIds(param) {
    return request({
        url: orderCustomer + '/scenicCardAction/findAppScenicCardListByGroupIds',
        data: param,
        method: 'post'
    })
}

//查询年卡支付状态
export function checkPayStatus(params) {
	return request({
		url: orderCustomer + '/capi' + '/orderOnlinePayAction/checkPayStatus',
		method: 'post',
		data: params
	});
}

// 获取门票详情
export function queryShopTicketByNo(params) {
    return request({
      url: baseScenic + '/scenicTicketRemoteAction/queryShopTicketByNo',
      method: 'post',
      data: params
    });
  }

// 删除会员常用联系人
export function deleteMemberFrequentContact(params) {
    return request({
      url: baseMember  +api+'/memberFrequentContactAction/deleteMemberFrequentContact',
      method: 'post',
      data: params
    });
}

// 添加常用联系人
export function addMemberFrequentContact(params) {
    return request({
      url: baseMember  +api+ '/memberFrequentContactAction/addMemberFrequentContact',
      method: 'post',
      data: params
    });
  }
  
  // 修改常用联系人
  export function updateMemberFrequentContact(params) {
    return request({
      url: baseMember +api+ '/memberFrequentContactAction/updateMemberFrequentContact',
      method: 'post',
      data: params
    });
  }

  // 查询二销项目列表
export function findProgramPlanListByProjectId(params) {
    return request({
      url: baseScenic + '/scenicTicketRemoteAction/findProgramPlanListByProjectId',
      method: 'post',
      data: params
    });
  }

//查询年卡详情
export function findAppScenicCardById(params) {
	return request({
		url: orderCustomer + '/scenicCardAction/findAppScenicCardById',
		method: 'post',
		data: params
	});
}

//人脸检测
export function confirmFace(params) {
	return request({
		url: baseMember  + api+'/memberInfoAction/confirmFace',
		method: 'post',
    headers: { "Content-Type": "multipart/form-data" },
		data: params
	});
}

//上传人脸
export function uploadFile(params) {
	return request({
		url: fileUploadUrl  + api+'/fileAction/uploadFile',
		method: 'post',
    headers: { "Content-Type": "multipart/form-data" },
		data: params
	});
}

// 照片质量验证
export function checkFaceQuality(params) {
  return request({
    url: faceUrl+ '/faceServerApi/facePhotoValid',
    method: 'post',
    data: params
  });
}

//售卡
export function appSaleCard(params) {
	return request({
		url: orderCustomer + api + '/scenicCardAction/appSaleCard',
		method: 'post',
		data: params
	});
}

//生成签名文件
export function getPdfFileUrl(params) {
	return request({
		url: orderCustomer + '/capi/yearCardProtocolAction/savePdfFile',
		method: 'post',
		data: params
	});
}

// 获取顶部轮播图
export function getAppBanner(params) {
	return request({
		url: orderInformation + '/bannerLoopAction/findBannerListByGroupNo',
		method: 'post',
		data: params
	});
}

//门票预订
export function getPriceCalendar(params) {
  return request({
    url: baseScenic + api + '/miniAppRealTimePriceAction/getPriceCalendar',
    method: 'post',
    data: params
  });
}

// 获取省份
export function findProvinceSelect(params) {
	return request({
		url: baseNew+'/capi/provinceAction/findProvinceSelect',
		method: 'post',
		data: params
	});
}

// 获取城市
export function findCitySelect(params) {
	return request({
		url: baseNew+'/capi/cityAction/findCitySelect',
		method: 'post',
		data: params
	});
}

// 获取区县
export function findDistrictSelect(params) {
	return request({
		url: baseNew+'/capi/districtAction/findDistrictSelect',
		method: 'post',
		data: params
	});
}